import { api } from "./api";

export async function requestPaymentRefund(paymentId, reason) {
  if (!paymentId) {
    throw new Error("A payment id is required to request a refund.");
  }
  if (!String(reason || "").trim()) {
    throw new Error("A refund reason is required.");
  }

  return api.patchJson(`/payments/${paymentId}/refund/`, { reason: String(reason).trim() });
}

export async function approvePaymentRefund(paymentId) {
  if (!paymentId) {
    throw new Error("A payment id is required to approve a refund.");
  }
  return api.patchJson(`/payments/${paymentId}/approve-refund/`, {});
}

export async function rejectPaymentRefund(paymentId, reason) {
  if (!paymentId) {
    throw new Error("A payment id is required to reject a refund.");
  }
  if (!String(reason || "").trim()) {
    throw new Error("A rejection reason is required.");
  }
  return api.patchJson(`/payments/${paymentId}/reject-refund/`, { reason: String(reason).trim() });
}

export async function getArtistSales(params = "") {
  return api.getJson(`/payments/artist-sales/${params ? `?${params}` : ""}`);
}

export async function getHostSales(params = "") {
  return api.getJson(`/payments/host-sales/${params ? `?${params}` : ""}`);
}

export async function exportArtistSalesCsv(params = "") {
  return api.get(`/payments/artist-sales-export/${params ? `?${params}` : ""}`);
}

export async function exportHostSalesCsv(params = "") {
  return api.get(`/payments/host-sales-export/${params ? `?${params}` : ""}`);
}
